import React, { FC } from 'react';

import Link from 'next/link';
import { useTranslation } from 'next-i18next/pages';

import { OFFICE_LANDING_URL, PRESS_RELEASE_URL } from '@/constants/routes';
import { TranslationNamespace } from '@/i18n';

import { NewsCard } from './NewsCard/NewsCard';

import styles from './NewsSection.module.scss';

export const NewsSection: FC = () => {
	const { t } = useTranslation(TranslationNamespace.Marketing);
	return (
		<section className={styles.newsSection}>
			<div className={styles.title}>{t('about-us-container.platform-news')}</div>
			<div className={styles.newsCardsBlock}>
				<NewsCard
					title={t('about-us-container.exchange-news-title')}
					description={
						<div>
							{t('about-us-container.exchange-news-description')}
							<br />
							<br />
							<Link className={styles.link} href={PRESS_RELEASE_URL}>
								{t('about-us-container.press-release')}
							</Link>
						</div>
					}
				/>
				<NewsCard
					title={t('about-us-container.digital-office-news-title')}
					description={
						<div>
							{t('about-us-container.digital-office-news-prefix')}{' '}
							<a className={styles.link} href={OFFICE_LANDING_URL} target="_blank" rel="noreferrer">
								{t('about-us-container.digital-office')}
							</a>{' '}
							{t('about-us-container.digital-office-news-suffix')}
							<br />
							<br />
							{t('about-us-container.digital-office-news-benefits')}
						</div>
					}
				/>
			</div>
		</section>
	);
};
